import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWordAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7418_53809)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.8 0C2.14903 0 0 2.14903 0 4.8V19.2C0 21.851 2.14903 24 4.8 24H19.2C21.851 24 24 21.851 24 19.2V7.65685C24 6.59599 23.5786 5.57857 22.8284 4.82843L18.7029 0.702944C18.2529 0.252856 17.6424 0 17.0059 0H4.8ZM2.55234 13.5272L4.15334 19.2H5.16712L6.30554 15.2196H6.34986L7.48551 19.2H8.49929L10.1003 13.5272H8.9951L7.97301 17.6987H7.92315L6.82905 13.5272H5.82358L4.73224 17.6959H4.67962L3.65753 13.5272H2.55234Z",
			fill: "#4F49BA"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.5 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L24 6H18.9C17.5745 6 16.5 4.92548 16.5 3.6V0Z",
			fill: "white",
			fillOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7418_53809",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgWordAttachment;
